import { uri } from '../../api-endpoint';
import { IModelFromAPISuccessResponse } from '../../type-conversion/model/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchModelListAPI = (token: string) => (companyId: number) =>
  fetchListTemplateFn(
    token,
    uri.modelListOfCompany(companyId),
    IModelFromAPISuccessResponse
  );
